"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var constants_1 = require("../data/constants");
var files_1 = __importDefault(require("../services/files"));
var IndexedDb_1 = __importDefault(require("../services/IndexedDb"));
var FileUpload = /** @class */ (function (_super) {
    __extends(FileUpload, _super);
    function FileUpload() {
        var _this = this;
        var _a;
        _this = _super.call(this, constants_1.DATA_FILEUPLOAD) || this;
        // Drag and drop function
        _this.dragAndDrop = function () {
            var _a, _b, _c;
            (_a = _this.dropArea) === null || _a === void 0 ? void 0 : _a.addEventListener('dragover', function (e) {
                e.preventDefault();
                // Add dragover class when hovering
                _this.dropArea.classList.add('is-dragover');
            });
            (_b = _this.dropArea) === null || _b === void 0 ? void 0 : _b.addEventListener('dragleave', function () {
                // Remove dragover class when leaving
                _this.dropArea.classList.remove('is-dragover');
            });
            (_c = _this.dropArea) === null || _c === void 0 ? void 0 : _c.addEventListener('drop', function (e) {
                // Prevent browser default behaviour (e.g. opening file in new tab)
                e.preventDefault();
                // Remove dragover class when dropped
                _this.dropArea.classList.remove('is-dragover');
                // Get all dropped files
                _this.fileInput.files = e.dataTransfer.files;
                _this.fileInput.dispatchEvent(new Event('change'));
            });
        };
        // File input change function
        _this.selectFilesViaClick = function () {
            var _a;
            (_a = _this.fileInput) === null || _a === void 0 ? void 0 : _a.addEventListener('change', _this.getFiles);
        };
        _this.loadFilesFromDatabase = function () {
            _this.database.getAll().then(function (items) {
                items.forEach(function (item) {
                    files_1.default.setFile(new File([item.file], item.name, {
                        type: item.type,
                        lastModified: item.lastModified
                    }), item.hash);
                });
                _this.fileNameAndSize();
            });
        };
        _this.getFiles = function () {
            var files = _this.fileInput.files;
            var _loop_1 = function (index) {
                var file = files.item(index);
                _this.database.hash(file).then(function (fileHash) { return __awaiter(_this, void 0, void 0, function () {
                    var fileReader;
                    var _this = this;
                    return __generator(this, function (_a) {
                        fileReader = new FileReader();
                        fileReader.readAsArrayBuffer(file);
                        fileReader.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this.database.add({
                                            hash: fileHash,
                                            name: file.name,
                                            type: file.type,
                                            lastModified: file.lastModified,
                                            file: fileReader.result
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        files_1.default.setFile(file, fileHash);
                        return [2 /*return*/];
                    });
                }); });
            };
            for (var index = 0; index < files.length; index++) {
                _loop_1(index);
            }
            _this.fileNameAndSize();
        };
        _this.removeFileViaClick = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var target, parent, fileHash;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        target = event.target;
                        parent = target.closest("[".concat(constants_1.DATA_FILEUPLOAD_ITEM, "]"));
                        parent.remove();
                        fileHash = parent.getAttribute(constants_1.DATA_FILEHASH);
                        return [4 /*yield*/, this.database.remove(fileHash)];
                    case 1:
                        _a.sent();
                        files_1.default.removeFile(fileHash);
                        setTimeout(function () {
                            // Needs to stay, otherwise not all files are added to the email
                            _this.fileInput.files = files_1.default.getFilesAsDataTransfer().files;
                        }, 100);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.fileNameAndSize = function () {
            var FileUploadWrap = _this.getChildElement("[".concat(constants_1.DATA_FILEUPLOADS, "]"));
            var files = files_1.default.getFiles();
            setTimeout(function () {
                files.forEach(function (element, index) {
                    var item = _this.createFileNode(element.file, index, element.hash);
                    if (item) {
                        FileUploadWrap.appendChild(item);
                        files_1.default.setFile(element.file, item.getAttribute(constants_1.DATA_FILEHASH));
                    }
                });
                // Needs to stay, otherwise not all files are added to the email
                _this.fileInput.files = files_1.default.getFilesAsDataTransfer().files;
            }, 100);
        };
        new files_1.default();
        _this.dropArea = _this.getChildElement("[".concat(constants_1.DATA_FILEUPLOAD_DROP_AREA, "]"));
        _this.fileInput = _this.getChildElement("[".concat(constants_1.DATA_FILEUPLOAD_INPUT, "]"));
        //new FilesService();
        _this.dragAndDrop();
        _this.selectFilesViaClick();
        _this.database = new IndexedDb_1.default();
        if (((_a = _this.fileInput) === null || _a === void 0 ? void 0 : _a.files.length) > 0) {
            _this.getFiles();
        }
        else if (typeof _this.fileInput !== 'undefined') {
            _this.loadFilesFromDatabase();
        }
        return _this;
    }
    FileUpload.prototype.createFileNode = function (file, index, hash) {
        var fileInformation = this.getFileInfo(file);
        if (this.getChildElement("[".concat(constants_1.DATA_FILEHASH, "='").concat(hash, "']")))
            return;
        var template = this.getChildElement("[".concat(constants_1.DATA_FILEUPLOAD_TEMPLATE, "]"));
        var fileItem = template.cloneNode(true);
        fileItem.removeAttribute(constants_1.DATA_FILEUPLOAD_TEMPLATE);
        fileItem.classList.remove('d-none');
        fileItem.setAttribute(constants_1.DATA_FILEUPLOAD_ITEM, index.toString());
        fileItem.setAttribute(constants_1.DATA_FILEHASH, hash);
        fileItem.querySelector("[".concat(constants_1.DATA_FILENAME, "]")).textContent = fileInformation.name;
        fileItem.querySelector("[".concat(constants_1.DATA_FILESIZE, "]")).textContent = fileInformation.size;
        fileItem.querySelector("[".concat(constants_1.DATA_REMOVE_FILE, "]")).addEventListener('click', this.removeFileViaClick);
        return fileItem;
    };
    FileUpload.prototype.getFileInfo = function (file) {
        var size = file.size, name = file.name, type = file.type;
        var readableSize;
        if (size >= 1048576) {
            readableSize = (size / 1048576).toFixed(2) + 'MB';
        }
        else {
            readableSize = (size / 1024).toFixed(2) + 'KB';
        }
        return {
            name: name,
            size: readableSize,
            type: type
        };
    };
    return FileUpload;
}(abstractComponent_1.default));
exports.default = FileUpload;
